export const SELECTION_STATUS = {
  draft: { label: '未分享', tone: 'neutral' },
  selecting: { label: '选片中', tone: 'warm' },
  submitted: { label: '已提交', tone: 'success' },
  expired: { label: '已过期', tone: 'danger' },
};

export const PAYMENT_STATUS = {
  none: { label: '无需支付', tone: 'neutral' },
  unpaid: { label: '待支付', tone: 'warm' },
  pending: { label: '支付中', tone: 'brand' },
  partial: { label: '部分支付', tone: 'warm' },
  paid: { label: '已支付', tone: 'success' },
  refunded: { label: '已退款', tone: 'neutral' },
};

export const ORDER_WORKFLOW_STEPS = {
  step1: { id: 'step1', label: '选片设置' },
  step2: { id: 'step2', label: '照片配置' },
  step3: { id: 'step3', label: '照片管理' },
  step4: { id: 'step4', label: '分享交付' },
  step5: { id: 'step5', label: '选图记录' },
};

const LEGACY_SELECTION_STATUS = {
  active: 'selecting',
  completed: 'submitted',
  ended: 'submitted',
};

export function getSelectionStatus(value) {
  if (!value) return undefined;
  if (value.orderStatus) return value.orderStatus;
  if (value.selectionStatus) return value.selectionStatus;
  return LEGACY_SELECTION_STATUS[value.status] || value.status;
}

export function getPaymentStatus(value) {
  if (!value) return undefined;
  if (value.paymentStatus) return value.paymentStatus;
  if (typeof value.isPaid === 'boolean') return value.isPaid ? 'paid' : 'unpaid';
  return undefined;
}

export function isPaymentPaid(value) {
  return getPaymentStatus(value) === 'paid';
}

export function hasOrderSelections(value) {
  const status = getSelectionStatus(value);
  return Number(value?.selectionNum || 0) > 0
    || Number(value?.selectedPhotoCount || 0) > 0
    || status === 'submitted';
}

export function orderCreationNextStep(value) {
  const enabled = value?.openWatermark === true
    || value?.openWatermark === 1
    || value?.openWatermark === '1';
  const configured = String(value?.watermark || '').trim().length > 0
    && Number(value?.watermarkFontSize || 0) > 0
    && Number(value?.watermarkAlpha || 0) > 0;
  return enabled && configured
    ? ORDER_WORKFLOW_STEPS.step3
    : ORDER_WORKFLOW_STEPS.step2;
}

export function orderWorkflowStep(value) {
  if (hasOrderSelections(value)) return ORDER_WORKFLOW_STEPS.step5;
  const status = getSelectionStatus(value);
  const isShared = !!value?.Album?.password
    || status === 'selecting'
    || status === 'expired';
  if (isShared || Number(value?.Album?.pictureCount || 0) > 0) {
    return ORDER_WORKFLOW_STEPS.step4;
  }
  return ORDER_WORKFLOW_STEPS.step3;
}

export function selectionStatusMeta(value) {
  const status = getSelectionStatus(value);
  return { status, ...(SELECTION_STATUS[status] || { label: status || '未知', tone: 'neutral' }) };
}

export function paymentStatusMeta(value) {
  const status = getPaymentStatus(value);
  return { status, ...(PAYMENT_STATUS[status] || { label: status || '未知', tone: 'neutral' }) };
}
